import { Outlet } from 'react-router-dom';

const PublicLayout = () => {
  return (
    <div className="flex flex-col overflow-y-auto h-dvh">
      <Outlet />
    </div>
  );
};

export default PublicLayout;
